import { render, staticRenderFns } from "./project-issue-type.vue?vue&type=template&id=37792884"
import script from "./project-issue-type.vue?vue&type=script&lang=js"
export * from "./project-issue-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports